import { formatInTimeZone, fromZonedTime } from 'date-fns-tz'

export const MARKET_TIMEZONE = 'America/New_York'

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/
const DATE_MIDNIGHT_REGEX =
  /^(\d{4}-\d{2}-\d{2})T00:00:00(?:\.0+)?(?:Z|[+-]\d{2}:\d{2})?$/

export const parseMarketDate = (value) => {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }
  if (typeof value === 'number') {
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
  }
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return null
    if (DATE_ONLY_REGEX.test(trimmed)) {
      const date = fromZonedTime(`${trimmed}T00:00:00`, MARKET_TIMEZONE)
      return Number.isNaN(date.getTime()) ? null : date
    }
    const midnightMatch = trimmed.match(DATE_MIDNIGHT_REGEX)
    if (midnightMatch) {
      const date = fromZonedTime(
        `${midnightMatch[1]}T00:00:00`,
        MARKET_TIMEZONE
      )
      return Number.isNaN(date.getTime()) ? null : date
    }
    const date = new Date(trimmed)
    return Number.isNaN(date.getTime()) ? null : date
  }
  return null
}

export const marketDateKey = (value) => {
  const date = parseMarketDate(value)
  return date ? formatInTimeZone(date, MARKET_TIMEZONE, 'yyyy-MM-dd') : null
}

// Local-midnight Date on the market calendar day, for widgets that render in
// the browser's timezone (e.g. MUI pickers with AdapterDateFns).
export const marketDateToLocalDate = (value) => {
  const key = marketDateKey(value)
  if (!key) return null
  const [year, month, day] = key.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export const formatMarketDate = (value, formatStr = 'M/d/yyyy') => {
  const date = parseMarketDate(value)
  return date ? formatInTimeZone(date, MARKET_TIMEZONE, formatStr) : null
}

export const isMarketDateAfter = (date, compare = new Date()) => {
  const left = marketDateKey(date)
  const right = marketDateKey(compare)
  if (!left || !right) return false
  return left > right
}

export const isMarketDateBefore = (date, compare = new Date()) => {
  const left = marketDateKey(date)
  const right = marketDateKey(compare)
  if (!left || !right) return false
  return left < right
}
